var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 292,
    viewBox: "0 0 308 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M307.083 146L273.127 107.312L277.858 56.0983L227.619 44.6866L201.317 0.431641L154 20.75L106.683 0.431641L80.3808 44.6866L30.1416 55.9591L34.8733 107.172L0.916626 146L34.8733 184.688L30.1416 236.041L80.3808 247.452L106.683 291.707L154 271.25L201.317 291.568L227.619 247.313L277.858 235.902L273.127 184.688L307.083 146ZM126.167 215.583L70.5 159.917L90.1225 140.294L126.167 176.199L217.877 84.4883L237.5 104.25L126.167 215.583Z",
    fill: "#28A745"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/Done.5d4b5164a729ddacb9275546fbbf4f9a.svg";
export { ForwardRef as ReactComponent };